import React, { useContext } from 'react';
import ToggleSwitch from './ToggleSwitch';
import { ThemeContext } from '../theme';

/**
 * A single settings row with a label and a toggle on the right.
 * Used in the right-hand detail panel of the Settings screen.
 *
 * Props:
 *   label    — string
 *   checked  — boolean
 *   onChange — (newValue: boolean) => void
 *   isFirst  — boolean (rounds top corners)
 *   isLast   — boolean (rounds bottom corners, removes border)
 */
export default function SettingsToggleRow({ label, checked, onChange, isFirst, isLast }) {
  const theme = useContext(ThemeContext);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        minHeight: 44,
        padding: '8px 16px',
        backgroundColor: theme.cardBg,
        borderBottom: isLast ? 'none' : `1px solid ${theme.border}`,
        borderTopLeftRadius: isFirst ? 16 : 0,
        borderTopRightRadius: isFirst ? 16 : 0,
        borderBottomLeftRadius: isLast ? 16 : 0,
        borderBottomRightRadius: isLast ? 16 : 0,
        flexShrink: 0,
      }}
    >
      <span
        className="font-satoshi"
        style={{
          flex: 1,
          fontSize: 13,
          lineHeight: '18px',
          fontWeight: 500,
          color: theme.text100,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </span>
      <ToggleSwitch checked={checked} onChange={onChange} scale={0.82} />
    </div>
  );
}
